import queries from '@apis/queries';
import {
    ACCESS_TOKEN_MAX_AGE_SECOND,
    REFRESH_TOKEN_MAX_AGE_SECOND,
} from '@constants/auth';
import useOnLifecycleChanged from '@hooks/native/useOnLifecycleChanged';
import { SignInResponse } from '@models/auth';
import { useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { useCookies } from 'react-cookie';

const MAX_LEAVE_TIME = 3600;

function useLifeCycleReIssue() {
    const [cookies, setCookies] = useCookies(['refreshToken', 'accessToken']);
    const { refreshToken } = cookies;
    const queryClient = useQueryClient();

    useOnLifecycleChanged({
        deps: [refreshToken],
        callbackFn: async (leaveTime?: number) => {
            if (leaveTime !== undefined) {
                try {
                    if (leaveTime >= MAX_LEAVE_TIME) {
                        window.location.href = '/';
                    }
                    if (refreshToken) {
                        const res = (await reissueToken(refreshToken)).data;
                        setCookies('accessToken', res.token, {
                            path: '/',
                            maxAge: ACCESS_TOKEN_MAX_AGE_SECOND,
                        });
                        setCookies('refreshToken', res.refreshToken, {
                            path: '/',
                            maxAge: REFRESH_TOKEN_MAX_AGE_SECOND,
                        });
                        queryClient.invalidateQueries({ queryKey: queries.user._def });
                        queryClient.invalidateQueries({ queryKey: queries.cart._def });
                        queryClient.invalidateQueries({ queryKey: queries.notifications._def });
                        queryClient.invalidateQueries({ queryKey: queries.stamps._def });
                        queryClient.invalidateQueries({ queryKey: queries.coupons._def });
                        queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
                        queryClient.invalidateQueries({ queryKey: queries.shop._def });
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
    });
}

function reissueToken(refreshToken: string): Promise<AxiosResponse<SignInResponse>> {
    return axios.post(
        `${import.meta.env.VITE_API_URL}/auth/token/refresh`,
        { refreshToken },
    );
}

export default useLifeCycleReIssue;
